import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { FormInputsProps } from '../types';
import classNames from 'classnames';
import { PasswordInput } from 'src/components/Inputs/PasswordInput';

export const FormPasswordInput: FC<FormInputsProps> = ({ field, defaultValue }) => {
  const { name, title, toShow } = field;
  const { register } = useFormContext();

  return (
    <PasswordInput
      {...register(name, { required: { value: toShow, message: 'validation.valueRequired' } })}
      className={classNames(!toShow && 'hidden')}
      placeholder={title}
      label={title}
      id={name}
      defaultValue={defaultValue}
      inputWrapperProps={{ className: classNames({ hidden: !toShow }) }}
    />
  );
};
